import { useState } from "react";
import { Sparkles, ArrowUp, X } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function AskBar() {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState(null);
  const [loading, setLoading] = useState(false);

  const ask = async (e) => {
    e.preventDefault();
    const question = q.trim();
    if (!question || loading) return;
    setLoading(true);
    setAnswer(null);
    try {
      const { data } = await api.post("/assistant/query", { question });
      setAnswer(data.answer);
    } catch (err) {
      setAnswer(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="ask-bar" className="relative">
      <form onSubmit={ask} className="relative">
        <Sparkles className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-gold pointer-events-none" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="ask-input"
          placeholder="Ask about your data — e.g. “Which location had the highest net income in June?”"
          className="w-full bg-brand-surface border border-brand-border hover:border-brand-borderStrong focus:border-brand-primary rounded-full pl-11 pr-14 py-3 text-sm text-brand-ink placeholder:text-brand-tertiary focus:outline-none transition-colors duration-200"
        />
        <button
          type="submit" disabled={loading || !q.trim()} data-testid="ask-submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 flex items-center justify-center rounded-full bg-brand-primary text-brand-page disabled:opacity-40 hover:bg-brand-primaryHover transition-all active:scale-95"
        >
          {loading ? <span className="h-4 w-4 rounded-full border-2 border-brand-page/40 border-t-brand-page animate-spin" /> : <ArrowUp className="h-4 w-4" />}
        </button>
      </form>

      {(answer || loading) && (
        <div data-testid="ask-answer" className="mt-3 bg-brand-surface border border-brand-border rounded-2xl p-4 flex items-start gap-3">
          <Sparkles className="h-4 w-4 text-brand-gold mt-0.5 shrink-0" />
          <p className="text-sm text-brand-ink leading-relaxed flex-1">
            {loading ? <span className="text-brand-tertiary">Thinking…</span> : answer}
          </p>
          {!loading && (
            <button onClick={() => setAnswer(null)} data-testid="ask-clear" className="text-brand-tertiary hover:text-brand-ink shrink-0">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
